// Copyright (c) Jupyter Development Team.
// Copyright (c) Microsoft Corporation.
// Distributed under the terms of the Modified BSD License.
import { css } from '@microsoft/fast-element';
import { AccentButtonStyles, BaseButtonStyles, HypertextStyles, LightweightButtonStyles, OutlineButtonStyles, StealthButtonStyles } from '../styles/index.js';
import { appearanceBehavior } from '../utilities/behaviors.js';
/**
 * Styles for Anchor
 * @public
 */
export const anchorStyles = (context, definition) => css `
    ${BaseButtonStyles}
  `.withBehaviors(appearanceBehavior('accent', AccentButtonStyles), appearanceBehavior('hypertext', HypertextStyles), appearanceBehavior('lightweight', LightweightButtonStyles), appearanceBehavior('outline', OutlineButtonStyles), appearanceBehavior('stealth', StealthButtonStyles));
